var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultingExpEx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_6023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.75 30.25H38.5",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.75 33.9167H33.9167",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5841 22.9166C26.5416 21.8218 26.7259 20.7301 27.1254 19.7099C27.525 18.6897 28.1312 17.7631 28.9059 16.9884C29.6806 16.2137 30.6072 15.6075 31.6274 15.208C32.6475 14.8084 33.7393 14.6241 34.8341 14.6666C35.9289 14.6241 37.0207 14.8084 38.0409 15.208C39.0611 15.6075 39.9876 16.2137 40.7623 16.9884C41.5371 17.7631 42.1432 18.6897 42.5428 19.7099C42.9423 20.7301 43.1266 21.8218 43.0841 22.9166H26.5841Z",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.834 11.9167C37.8715 11.9167 40.334 9.45431 40.334 6.41675C40.334 3.37918 37.8715 0.916748 34.834 0.916748C31.7964 0.916748 29.334 3.37918 29.334 6.41675C29.334 9.45431 31.7964 11.9167 34.834 11.9167Z",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2802 5.65218C39.3083 6.16516 38.2239 6.4279 37.125 6.41668C35.8337 6.41713 34.5684 6.05382 33.4741 5.36836C32.3798 4.6829 31.5007 3.70303 30.9375 2.54102",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.916146 43.0834C0.873618 41.9886 1.05792 40.8968 1.45747 39.8766C1.85702 38.8564 2.4632 37.9299 3.23793 37.1552C4.01265 36.3804 4.9392 35.7743 5.95938 35.3747C6.97956 34.9752 8.07134 34.7909 9.16615 34.8334C10.261 34.7909 11.3527 34.9752 12.3729 35.3747C13.3931 35.7743 14.3196 36.3804 15.0944 37.1552C15.8691 37.9299 16.4753 38.8564 16.8748 39.8766C17.2744 40.8968 17.4587 41.9886 17.4161 43.0834H0.916146Z",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 32.0833C12.2036 32.0833 14.666 29.6208 14.666 26.5833C14.666 23.5457 12.2036 21.0833 9.16602 21.0833C6.12845 21.0833 3.66602 23.5457 3.66602 26.5833C3.66602 29.6208 6.12845 32.0833 9.16602 32.0833Z",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.618 25.8499C13.6579 26.3434 12.5918 26.5951 11.5124 26.5832C10.2134 26.5834 8.94101 26.2157 7.8424 25.5226C6.7438 24.8296 5.86394 23.8396 5.30469 22.6672",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9173 26.5833C22.4311 26.5833 21.9648 26.7764 21.621 27.1202C21.2771 27.464 21.084 27.9304 21.084 28.4166V37.5833C21.084 38.0695 21.2771 38.5358 21.621 38.8796C21.9648 39.2234 22.4311 39.4166 22.9173 39.4166H25.6673V43.0833L30.2507 39.4166H41.2506C41.7369 39.4166 42.2032 39.2234 42.547 38.8796C42.8908 38.5358 43.084 38.0695 43.084 37.5833V28.4166C43.084 27.9304 42.8908 27.464 42.547 27.1202C42.2032 26.7764 41.7369 26.5833 41.2506 26.5833H22.9173Z",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.334 4.58325H4.58398",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7507 8.25H4.58398",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0827 0.916748C21.5689 0.916748 22.0352 1.1099 22.379 1.45372C22.7229 1.79754 22.916 2.26385 22.916 2.75008V11.9167C22.916 12.403 22.7229 12.8693 22.379 13.2131C22.0352 13.5569 21.5689 13.7501 21.0827 13.7501H18.3327V18.3334L13.7493 13.7501H2.74935C2.26312 13.7501 1.7968 13.5569 1.45299 13.2131C1.10917 12.8693 0.916016 12.403 0.916016 11.9167V2.75008C0.916016 2.26385 1.10917 1.79754 1.45299 1.45372C1.7968 1.1099 2.26312 0.916748 2.74935 0.916748H21.0827Z",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_6023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultingExpEx);
export default __webpack_public_path__ + "static/media/consulting_exp_ex.a11a381be21035129ce7f4ba428ad374.svg";
export { ForwardRef as ReactComponent };